module.exports = __webpack_public_path__ + "static/media/eletrica.1b9d5b1c.svg";